import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rlsCharts: {
    demoOrgs: {
      loading: false,
      error: null,
      data: [],
      progress: {
        percent: 0,
        completedApiCalls: 0,
        totalApiCalls: 0
      }
    }
  }
};

export const chartsSlice = createSlice({
  name: 'charts',
  initialState,
  reducers: {
    setDemoOrgs: (state, action) => {
      state.rlsCharts.demoOrgs.data = action.payload.data;
      state.rlsCharts.demoOrgs.loading = action.payload.loading;
      state.rlsCharts.demoOrgs.error = action.payload.error;
    },
    updateDemoOrgsProgress: (state, action) => {
      state.rlsCharts.demoOrgs.progress = {
        ...state.rlsCharts.demoOrgs.progress,
        ...action.payload
      };
    }
  }
});

export const { setDemoOrgs, updateDemoOrgsProgress } = chartsSlice.actions;

export default chartsSlice.reducer;
